/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 模板类型
 */
let EnumStationType = {
	Water: 						new EnumItem('地表水', 0,'water'),
	Pollution: 					new EnumItem('污染源', 1,'pollution'),
	undergroundWater: 			new EnumItem('地下水', 2,'undergroundWater'),
	pipeNetwork:                new EnumItem('管网', 3,'pipeNetwork'),
	...enumMixn
}
export default EnumStationType
